import { Box, Grid, IconButton, Stack, } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MaterialTypography from '../../../../../../../components/MaterialTypography'
import MaterialInput from '../../../../../../../components/MaterialInput'
import MaterialButton from '../../../../../../../components/MaterialButton';
import DeleteIcon from '@mui/icons-material/Delete';
import MaterialSelect from '../../../../../../../components/MaterialSelect';
import FileSelector from '../../../../../../../components/fileSelector';
import { BASE_URL } from '../../../../../../Utils/Baseurl';
import axios from 'axios';


const styles = {
    scrollContainer: {
        maxHeight: '500px',
        overflowY: 'auto',
        paddingRight: '8px',
        scrollbarWidth: 'thin',
        scrollbarColor: '#ccc transparent',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#ccc',
            borderRadius: '4px',
        },
    },
};

const AddTestCase = ({ testCaseData, steps, setSteps, handleAddStep, handleStepChange, handleDeleteStep, handleTestCaseDataChange, selectedProject }) => {

    const [options, setOptons] = useState([]);
    const [employees, setEmpoyees] = useState([]);

    useEffect(() => {
        fetchOptionsTestCase()
    }, [])

    useEffect(() => {
        const fetchProjectEmployees = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const response = await axios.get(`${BASE_URL}api/project_employees/?project_id=${selectedProject?.value}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const employees = response.data?.data?.map(emp => ({
                    label: emp.employee_name,
                    value: emp.id
                }));
                setEmpoyees(employees)
            } catch (error) {
                console.error("Error fetching project employees:", error);
            }
        }
        if (selectedProject) {
            fetchProjectEmployees();
        }
    }, [selectedProject]);

    const fetchOptionsTestCase = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await axios.get(`${BASE_URL}api/testcase_choices/`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            const data = response.data;
            console.log(response.data, 'options')
            setOptons(prev => ({ ...prev, ...data }));
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <Grid container spacing={2} sx={{ padding: 1 }}>
            <Grid size={{ xs: 9, sm: 9, md: 9 }}>
                <Box sx={styles.scrollContainer}>
                    <Grid container spacing={2} sx={{ padding: 1 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack direction='column' spacing={0.5}>
                                <MaterialTypography variant='caption' color='text' fontWeight='bold'>Title<span style={{ color: 'red' }}>*</span></MaterialTypography>
                                <MaterialInput
                                    placeholder='Enter test case title'
                                    fullWidth
                                    size='small'
                                    value={testCaseData.title}
                                    onChange={(e) => handleTestCaseDataChange('title', e.target.value)}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack direction='column' spacing={0.5}>
                                <MaterialTypography variant='caption' color='text' fontWeight='bold'>Description</MaterialTypography>
                                <MaterialInput
                                    placeholder='Enter test case description'
                                    fullWidth
                                    multiline
                                    rows={4}
                                    size='small'
                                    value={testCaseData.description}
                                    onChange={(e) => handleTestCaseDataChange('description', e.target.value)}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack direction='column' spacing={0.5}>
                                <MaterialTypography variant='caption' color='text' fontWeight='bold'>Preconditions</MaterialTypography>
                                <MaterialInput
                                    placeholder='Enter expected result'
                                    fullWidth
                                    multiline
                                    rows={4}
                                    size='small'
                                    value={testCaseData.preconditions}
                                    onChange={(e) => handleTestCaseDataChange('preconditions', e.target.value)}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Box sx={{ mt: 0 }}>
                                <MaterialTypography variant="caption" fontWeight="bold" color="text">
                                    Steps and Results<span style={{ color: 'red' }}>*</span>
                                </MaterialTypography>

                                {steps.map((item, index) => (
                                    <Grid container spacing={2} key={index} alignItems="flex-start" sx={{ mb: 1 }}>
                                        <Grid size={{ xs: 1, sm: 1, md: 1 }} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Box
                                                component="span"
                                                sx={{
                                                    display: 'inline-block',
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#f1f1f1',
                                                    textAlign: 'center',
                                                    lineHeight: '24px',
                                                    ml: 1,
                                                }}
                                            >
                                                {index + 1}
                                            </Box>
                                        </Grid>

                                        <Grid size={{ xs: 5.5, sm: 5.5, md: 5.5 }} sx={{ position: 'relative' }}>
                                            <Stack direction='column' spacing={0.5} >
                                                <MaterialTypography variant="caption" color="text" >Step</MaterialTypography>
                                                <MaterialInput
                                                    placeholder="Details of the step"
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    value={item.step}
                                                    onChange={(e) => handleStepChange(index, 'step', e.target.value)}
                                                />
                                            </Stack>
                                        </Grid>

                                        <Grid size={{ xs: 5.5, sm: 5.5, md: 5.5 }} sx={{ position: 'relative' }}>
                                            <Stack direction='column' spacing={0.5} >
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <MaterialTypography variant="caption" color="text">Result</MaterialTypography>
                                                    {steps.length > 1 && index !== 0 && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleDeleteStep(index)}
                                                            sx={{ p: 0 }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: '16px', color: '#fc4e4e' }} />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                                <MaterialInput
                                                    placeholder="Expected Result"
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    value={item.result}
                                                    onChange={(e) => handleStepChange(index, 'result', e.target.value)}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <MaterialButton variant="contained" size='small' onClick={handleAddStep} sx={{ textTransform: 'none', color: '#4880c1', backgroundColor: '#afd2fa' }}>
                                        + Add Step
                                    </MaterialButton>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack direction='column' spacing={0.5}>
                                <MaterialTypography variant='caption' color='text' fontWeight='bold'>
                                    Attachments{!testCaseData.oneDriveLink && <span style={{ color: 'red' }}>*</span>}
                                </MaterialTypography>
                                <FileSelector
                                    onFileSelect={(file) => handleTestCaseDataChange('attachments', file)}
                                    fileUrl={testCaseData.attachments ? URL.createObjectURL(testCaseData.attachments) : null}
                                    allowedTypes={['image']}
                                    width="100%"
                                    height="150px"
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack direction='column' spacing={0.5}>
                                <MaterialTypography variant='caption' color='text' fontWeight='bold'>
                                    One Drive Link{!testCaseData.attachments && <span style={{ color: 'red' }}>*</span>}
                                </MaterialTypography>
                                <MaterialInput
                                    placeholder='Enter One Drive Link'
                                    fullWidth
                                    size='small'
                                    value={testCaseData.oneDriveLink}
                                    onChange={(e) => handleTestCaseDataChange('oneDriveLink', e.target.value)}
                                    error={testCaseData.oneDriveLink && !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(testCaseData.oneDriveLink)}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                <Grid container spacing={2} >
                    {/* <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                        <Stack direction='column' spacing={0.5}>
                            <MaterialTypography variant='caption' color='text' fontWeight='bold'>Owner<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                fullWidth
                                label='Select Owner'
                                options={employees}
                                size='small'
                                value={testCaseData.owner}
                                onChange={(option) => handleTestCaseDataChange('owner', option)}
                            />
                        </Stack>
                    </Grid> */}
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                        <Stack direction='column' spacing={0.5}>
                            <MaterialTypography variant='caption' color='text' fontWeight='bold'>Priority<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                fullWidth
                                label='Select Priority'
                                options={options?.priority}
                                isIcon={true}
                                size='small'
                                value={testCaseData.priority}
                                onChange={(option) => handleTestCaseDataChange('priority', option)}
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                        <Stack direction='column' spacing={0.5}>
                            <MaterialTypography variant='caption' color='text' fontWeight='bold'>State<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                fullWidth
                                label='Select State'
                                options={options?.test_state}
                                isIcon={true}
                                size='small'
                                value={testCaseData.testCaseState}
                                onChange={(option) => handleTestCaseDataChange('testCaseState', option)}
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                        <Stack direction='column' spacing={0.5}>
                            <MaterialTypography variant='caption' color='text' fontWeight='bold'>Type of test case<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                fullWidth
                                label='Select Type'
                                options={options?.test_case_type}
                                size='small'
                                value={testCaseData.testCaseType}
                                onChange={(option) => handleTestCaseDataChange('testCaseType', option)}
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                        <Stack direction='column' spacing={0.5}>
                            <MaterialTypography variant='caption' color='text' fontWeight='bold'>Automation Status<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                fullWidth
                                label='Select Automation Status'
                                options={options?.automation_status}
                                size='small'
                                value={testCaseData.automationStatus}
                                onChange={(option) => handleTestCaseDataChange('automationStatus', option)}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default AddTestCase
